import { React, useContext } from 'react';
import Icon from "../../../components/atoms/Icon";
import SportIcon from "../../../components/atoms/SportIcon";
import { ThemeContext } from '../../../components/molecules/Nav';
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import moment from 'moment';
import '../../Concession/concession.css';
import '../retail.css';

const HeaderNav = ({
    currentLocation,
    loading,
    isToday,
    selectedDate,
    showCalendar,
    setShowCalendar,
    dayType,
    setDayType,
    refreshRegularDay,
    setSelectedDate,
    games,
    now
}) => {
    const [theme] = useContext(ThemeContext);

    // Check if Regular Day should be shown
    const shouldShowRegularDay =
        !!currentLocation.dayTypes?.REGULAR &&
        !(currentLocation.doorCounterSensorIds?.length === 0 && currentLocation.maxOccupancy === 0);

    return (
        <div className="cx-header rx-header">
            <div className="cx-header-identity">
                <img
                    className="cx-header-logo"
                    src={
                        theme === "light" ? require(`../../../clients/${currentLocation.logoPath}`)
                            : require(`../../../clients/${currentLocation.logoPathDark}`)
                    }
                    alt="logo"
                />
                <div className="cx-header-divider" />
                <div style={{ minWidth: 0 }}>
                    <div className="cx-eyebrow">Retail</div>
                    <h1 className="cx-header-title">{currentLocation?.name}</h1>
                </div>
            </div>

            <div className="cx-header-actions">
                {isToday && selectedDate && (
                    <span className="cx-live-pill">
                        <span className="pulsing-dot" />
                        Live
                    </span>
                )}

                {/* Regular day date picker */}
                {dayType === "regular" && shouldShowRegularDay && (
                    <div className="rx-date">
                        <button
                            type="button"
                            className="cx-sort-btn"
                            onClick={() => setShowCalendar(!showCalendar)}
                            aria-expanded={showCalendar}
                        >
                            <Icon name="calendar3" />
                            {moment(selectedDate).format("ddd, MMM D, YYYY")}
                            {isToday ? " (Today)" : ""}
                            <Icon name={showCalendar ? 'chevron-up' : 'chevron-down'} className="cx-sort-caret" />
                        </button>

                        {showCalendar && (
                            <div className="rx-calendar-pop">
                                <Calendar
                                    tileDisabled={({ date }) => {
                                        let allDates = [];
                                        for (let x = 0; x < games.length; x++) {
                                            for (let y = 0; y < games[x].dates.length; y++) {
                                                allDates.push(
                                                    moment(games[x].dates[y].date)
                                                        .startOf("day")
                                                        .format()
                                                );
                                            }
                                        }
                                        return allDates.includes(
                                            moment(date).startOf("day").format()
                                        );
                                    }}
                                    minDate={new Date(currentLocation.calendarMinDate)}
                                    onChange={(date) => {
                                        setSelectedDate(date);
                                        setShowCalendar(false);
                                    }}
                                    value={selectedDate}
                                    maxDate={now}
                                    showNeighboringMonth={false}
                                />
                                <div className="rx-calendar-note">Game days are picked from Game Day.</div>
                            </div>
                        )}
                    </div>
                )}

                <div className="cx-segmented" role="tablist">
                    <button
                        type="button"
                        role="tab"
                        aria-selected={dayType === "overview"}
                        disabled={loading}
                        onClick={() => {
                            if (showCalendar) {
                                setShowCalendar(false);
                            }
                            setDayType("overview");
                        }}
                        className={`cx-segmented-btn ${dayType === "overview" ? "active" : ""}`}
                    >
                        <Icon name="graph-up" />
                        Overview
                    </button>
                    {shouldShowRegularDay && (
                        <button
                            type="button"
                            role="tab"
                            aria-selected={dayType === "regular"}
                            disabled={loading}
                            onClick={() => setDayType("regular")}
                            className={`cx-segmented-btn ${dayType === "regular" ? "active" : ""}`}
                        >
                            <Icon name="sun-fill" />
                            Regular Day
                        </button>
                    )}
                    <button
                        type="button"
                        role="tab"
                        aria-selected={dayType === "game"}
                        disabled={loading}
                        onClick={() => setDayType("game")}
                        className={`cx-segmented-btn ${dayType === "game" ? "active" : ""}`}
                    >
                        <SportIcon fontSize="inherit" />
                        Game Day
                    </button>
                </div>
            </div>
        </div>
    );
};

export default HeaderNav;
